import CityPageTemplate from "../city-template/CityPageTemplate";
import { parkersburgConfig } from "./data";

export default function ParkersburgPage() {
  return <CityPageTemplate config={parkersburgConfig} />;
}